import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, IconButton, DialogContentText, Grid, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import useTheme from '@mui/material/styles/useTheme';
import IntlMessages from 'lngProvider/IntlMessages';
import ComponentContainer from 'containers/ComponentContainer';
import { styled } from '@mui/material/styles';
import { colors } from 'styles/Common';

const StyledDialog = styled(Dialog)((
    {
        theme
    }
    ) => {
        return {
            '& .print-icon': {
                stroke: colors.fillBlue00Brand // '#003ce6'
            },
            '& .tos-button-enabled': {
                color: colors.alertsStandardInfo // '#2661ea'
            },
            '& .tos-text-presentation': {
                wordBreak: "break-word",
                maxHeight: "363px"
            },
            '& .dialog-close-button': {
                position: 'absolute',
                top: 0,
                right: 0,
                padding: 5,
                lineHeight: '14px',
                minWidth: 'auto',
                textAlign: 'right'
            }
        };
    });
const TermsOfServiceModal = ({ values, open, terms, onHandleAgree, onHandleDisagree, onHandleClose, setValues, readOnly }) => {
    const [scrolledToBottom, setScrolledToBottom] = useState(false);
    const theme = useTheme();

    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - 10 <= e.target.clientHeight;
        setScrolledToBottom(bottom);
    };

    return (
        <ComponentContainer>
            {(props) => {
                return (
                    <StyledDialog
                        open={open}
                        keepMounted
                        terms={terms}
                        style={{ zIndex: theme.zIndex.modal + 2 }}>

                        <DialogTitle>
                            <Typography variant="body2"><IntlMessages id="termsOfUse.title" /></Typography>
                            <div className="dialog-close-button" onScroll={handleScroll}>
                                <IconButton onClick={() => onHandleClose(values, setValues)}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </DialogTitle>
                        <DialogContent dividers className="tos-text-presentation" onScroll={handleScroll}>
                            <DialogContentText variant="caption">
                                <span dangerouslySetInnerHTML={{ __html: props.intl.formatMessage({ id: "termsOfUse.acknowledgement" }) }}></span>
                            </DialogContentText>
                            <DialogContentText variant="caption">
                                <span dangerouslySetInnerHTML={{ __html: terms }}></span>
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                {/*<Grid item>*/}
                                {/*    <NavLink target="_blank" to="/termsofservice"><IconButton onClick={onPrintClicked}><PrinterLogo /></IconButton></NavLink>*/}
                                {/*</Grid>*/}
                                <Grid item>
                                    {
                                        readOnly ?
                                            null
                                            :
                                            <Button id="disagree" color="inherit" className="tos-button-enabled" variant="text" onClick={() => onHandleDisagree(values, setValues)}><b><IntlMessages id="termsOfUse.disagree" /></b></Button>
                                    }
                                    {
                                        readOnly ?
                                            null
                                            :
                                            <Button id="agree" disabled={!scrolledToBottom} color="inherit" className={!scrolledToBottom ? null : "tos-button-enabled"} variant="text" onClick={() => onHandleAgree(values, props)}><b><IntlMessages id="termsOfUse.agree" /></b></Button>
                                    }
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </StyledDialog>
                );
            }}
        </ComponentContainer>
    );
}

export default TermsOfServiceModal;